<template>
  <v-snackbar
    v-model="showSnackbarDialog"
    :color="snackbarColor"
    multi-line
    :timeout="timeout"
  >
    <ul v-if="Array.isArray(message)">
      <li v-for="(error, index) in message" :key="index">
        {{ error.message }} (error code: {{ error.code }})
      </li>
    </ul>
    <span v-else>
      {{ message }}
    </span>
    <v-btn class="pink--text" :color="closeBtnColor" text @click="$emit('setSnackbar', false)">
      Close
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  props: {
    showSnackbar: {
      type: Boolean,
      required: true,
    },
    message: {
      type: [Array, String],
    },
    timeout: {
      type: Number,
      default: 6000,
    },
    snackbarColor: {
      type: String,
    },
    closeBtnColor: {
      type: String,
    },
  },
  computed: {
    showSnackbarDialog: {
      get() {
        return this.showSnackbar;
      },
      set(newValue) {
        this.$emit('setSnackbar', newValue);
      },
    },
  },
};
</script>

<style></style>
